import React, { useEffect, useState } from "react";
import ModalLayout from "../../../../components/ModalLayout";
import { Box, Typography, useTheme } from "@mui/material";
import CustomButton from "../../../../components/CustomButton";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../../services/fetcher";
import { useAppDispatch, useAppSelector } from "../../../../../hooks/useRedux";
import { setUserStock } from "../../../../../redux/features/userSlice";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../../redux/features/snackbarSlice";
import {
  setDialogDescription,
  setDialogStatus,
  setDialogTitle,
  setOpenDialog,
} from "../../../../../redux/features/dialogSlice";

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  paymentState: boolean;
  setPaymentState: React.Dispatch<React.SetStateAction<boolean>>;
  amount?: string;
  trackCode?: string;
  link?: string;
}
export default function PaymentModal(props: Props) {
  const {
    open,
    setOpen,
    amount,
    link,
    trackCode,
    paymentState,
    setPaymentState,
  } = props;

  const theme = useTheme();

  const { stock: oldStock } = useAppSelector((state) => state.user);

  const dispatch = useAppDispatch();

  const {
    trigger: getDriverbarTrigger,
    isMutating: isGetDriverbarTriggerMutating,
  } = useSWRMutation(
    [`/Driver/GetDriverBar`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: async (data) => {
        const { stock } = data;

        if (stock === oldStock) {
          dispatch(setOpenDialog(true));
          dispatch(setDialogStatus("error"));
          dispatch(setDialogTitle("تراکنش ناموفق بود!"));
          dispatch(setDialogDescription(""));
          setTimeout(() => {
            dispatch(setOpenDialog(false));
            setPaymentState(false);
            setOpen(false);
          }, 3000);
        } else if (stock > oldStock!) {
          dispatch(setOpenDialog(true));
          dispatch(setDialogStatus("success"));
          dispatch(setDialogTitle("تراکنش با موفقیت انجام شد!"));
          dispatch(setDialogDescription(""));
          dispatch(setUserStock(stock));

          setTimeout(() => {
            dispatch(setOpenDialog(false));
            setPaymentState(false);
            setOpen(false);
          }, 3000);
        }
      },
    }
  );

  return (
    <ModalLayout open={open} setOpen={setOpen}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: "700",
          }}
        >
          در صورت صحیح بودن مبلغ شارژ لطفا کلید پرداخت را بزنید.
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "10px 8px",
              backgroundColor: theme.palette.bgColor.blueGrey50,
              boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.2) inset",
            }}
          >
            <Typography
              sx={{
                fontSize: "14px",
              }}
            >
              مبلغ شارژ:
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
            >
              {amount} تومان
            </Typography>
          </Box>
          <Box
            sx={{
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "10px 8px",
              backgroundColor: theme.palette.bgColor.blueGrey50,
              boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.2) inset",
            }}
          >
            <Typography
              sx={{
                fontSize: "14px",
              }}
            >
              کد پیگیری:
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
            >
              {trackCode}{" "}
            </Typography>
          </Box>
        </Box>

        {!paymentState ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            <a href={link} target="_blank" rel="noopener noreferrer">
              <CustomButton
                onClick={() => setPaymentState(true)}
                fWeight="700"
                title="پرداخت"
                bgColor="success.main"
                justifyContent="center"
                px="32px"
                py="10px"
                borderRadius="6px"
              />
            </a>
            <CustomButton
              onClick={() => {
                setOpen(false);
              }}
              title="انصراف"
              textColor="error.main"
              bgColor="error.light"
              justifyContent="center"
              borderColor="error.main"
              px="10px"
              py="10px"
              borderRadius="6px"
            />
          </Box>
        ) : (
          <CustomButton
            onClick={() => {
              getDriverbarTrigger();
            }}
            fWeight="700"
            title="استعلام پرداخت"
            bgColor="success.main"
            justifyContent="center"
            px="32px"
            py="10px"
            borderRadius="6px"
          />
        )}
      </Box>
    </ModalLayout>
  );
}
